// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eCZ-R","name":"styles_name__drGs5","phone":"styles_phone__2PkoX"};